import { render, staticRenderFns } from "./renameDialog.vue?vue&type=template&id=85e64850&scoped=true&"
import script from "./renameDialog.vue?vue&type=script&lang=js&"
export * from "./renameDialog.vue?vue&type=script&lang=js&"
import style0 from "./renameDialog.vue?vue&type=style&index=0&id=85e64850&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e64850",
  null
  
)

export default component.exports